import { announcements } from "@/mocks/mirrorData";

export default function DomainUpdate() {
  return (
    <section id="domain" className="scroll-mt-20 bg-background-100/60 py-16 md:py-24">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 md:px-6 lg:grid-cols-[1fr_1.3fr] lg:items-center">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-sm text-accent-800">
            <i className="ri-megaphone-line" /> 最新动态
          </span>
          <h2 className="mt-4 font-heading text-3xl text-foreground-950 md:text-4xl">新域名与公告</h2>
          <p className="mt-4 text-base leading-7 text-foreground-600">
            新地址启用、线路升级与维护进度都会在这里第一时间公布。建议常回本页查看，第一时间获取最新可用的永久入口。
          </p>
          <div className="mt-6 rounded-lg border border-accent-200 bg-accent-50 p-5">
            <p className="text-sm font-medium text-accent-900">当前推荐永久入口</p>
            <p className="mt-2 break-all font-mono text-lg text-foreground-950">new.benzi-home.net</p>
            <p className="mt-2 text-sm text-foreground-600">长期有效，建议优先收藏并加入书签。</p>
          </div>
        </div>
        <ol className="relative space-y-6 border-l border-background-300 pl-6">
          {announcements.map((a) => (
            <li key={a.id} className="relative">
              <span className="absolute -left-[1.85rem] top-1 flex h-6 w-6 items-center justify-center rounded-full bg-accent-500 text-background-50">
                <i className="ri-record-circle-line text-xs" />
              </span>
              <div className="rounded-lg border border-background-200 bg-background-50 p-5">
                <div className="flex items-center justify-between gap-3">
                  <h3 className="text-base font-semibold text-foreground-950">{a.title}</h3>
                  <span className="whitespace-nowrap text-xs text-foreground-500">{a.date}</span>
                </div>
                <p className="mt-2 text-sm leading-6 text-foreground-600">{a.content}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}